<div class="section-loader">
    <div class="loader">
        <div></div>
        <div></div>
    </div>
</div>